import { RegistrationRegister } from '../registration-register.model';
import { RegistrationItem } from '../registration-item.model';
import { RegistrationAttendee } from '../registration-attendee.model';
import { RegistrationCustomRegFieldResponse } from '../registration-custom-reg-field-response.model';
import { EventPromoCode } from '../../../shared/promo-codes/event-promo-code.model';

export class RegistrationRead {
  public EventId: number;
  public RegistrationId: number;
  public Registration: RegistrationRegister;
  public Items: Array<RegistrationItem>;
  public Attendees: Array<RegistrationAttendee>;
  public IsEdit: boolean;
  public PromoCodes: Array<EventPromoCode>;

  public constructor() {
    this.EventId = 0;
    this.RegistrationId = 0;
    this.Registration = new RegistrationRegister();
    this.Items = new Array<RegistrationItem>();
    this.Attendees = new Array<RegistrationAttendee>();
    this.IsEdit = false;
  }
}
